<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pv"></a>CONTENTS</h1>
<p class="tocfm"><a class="xref" href="#/chiyearsley0007#trans">Note on Translations and Musical Examples</a></p>
<p class="tocfm"><a class="xref" href="#/chiyearsley0008#lofigs">List of Figures</a></p>
<p class="tocfm"><a class="xref" href="#/chiyearsley0009#loex">List of Musical Examples</a></p>
<p class="tocfm"><a class="xref" href="#/chiyearsley0010#abbrs">List of Abbreviations</a></p>
<p class="tocfm"><a class="xref" href="#/chiyearsley0011#prog">Prologue</a></p>
<p class="toc"><a class="xref" href="#/chiyearsley0012#ch01">CHAPTER ONE  <i>Magdalena Mania</i></a></p>
<p class="toc"><a class="xref" href="#/chiyearsley0013#ch02">CHAPTER TWO  <i>Music for Weddings and Beddings</i></a></p>
<p class="toc"><a class="xref" href="#/chiyearsley0014#ch03">CHAPTER THREE  <i>Death Every Day: The 1725 Notebook and the Art of Dying</i></a></p>
<p class="toc"><a class="xref" href="#/chiyearsley0015#ch04">CHAPTER FOUR  <i>Fragment and Fantasy: Anna Magdalena Bach at the Organ</i></a></p>
<p class="toc"><a class="xref" href="#/chiyearsley0016#ch05">CHAPTER FIVE  <i>Bitter Bean and Loose Ließgen: On Coffee, Cantatas, and Unwed Daughters</i></a></p>
<p class="toc"><a class="page" id="pvi"></a><a class="xref" href="#/chiyearsley0017#ch06">CHAPTER SIX  <i>A Widow’s Song</i></a></p>
<p class="toc"><a class="xref" href="#/chiyearsley0018#coda">CODA  <i>The Minuet Sings</i></a></p>
<p class="tocbmf"><a class="xref" href="#/chiyearsley0019#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chiyearsley0020#app">Appendix: Table of Contents of Anna Magdalena Bach’s Notebooks</a></p>
<p class="tocbm"><a class="xref" href="#/chiyearsley0021#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chiyearsley0022#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chiyearsley0023#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-yearsley-0006.vue?53f40f02